import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import urlWithAuthParams from "enterprise-integrations/helpers/urlWithAuthParams";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { clientSecret } = formData;
  const subscriptions = [
    { label: t("o365.subscriptions.enterprise"), value: "ENTERPRISE" },
    { label: t("o365.subscriptions.gcc_high"), value: "GCC_HIGH" },
    { label: t("o365.subscriptions.dod"), value: "DOD" }
  ];
  const [O365ContentTypesStatus, setO365ContentTypes] = useFetch(
    null,
    onSubmit,
    "POST",
    {
      o365_tenant_id: ((_a = formData == null ? void 0 : formData.tenantId) == null ? void 0 : _a.value) || "",
      o365_client_id: ((_b = formData == null ? void 0 : formData.clientId) == null ? void 0 : _b.value) || "",
      o365_client_secret: ((_c = formData == null ? void 0 : formData.clientSecret) == null ? void 0 : _c.value) || "",
      o365_endpoint: ((_d = formData == null ? void 0 : formData.subscriptionType) == null ? void 0 : _d.value) || ""
    },
    urlWithAuthParams
  );
  useEffect(() => {
    setO365ContentTypes(null);
    if (O365ContentTypesStatus.error) {
      setFormError({
        full_message: O365ContentTypesStatus.error,
        nice_message: t("o365.errors.unable_to_connect")
      });
    }
    return () => {
      setFormError(null);
    };
  }, [O365ContentTypesStatus.error, setO365ContentTypes, t]);
  const handleSubmit = () => {
    setO365ContentTypes(ApiRoutes.INTEGRATIONS.O365.CONTENT_TYPES);
  };
  const isFormValid = formValidation.isFormValid(
    ["o365Name", "tenantId", "clientId", "clientSecret", "subscriptionType"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      loading: O365ContentTypesStatus.loading,
      disabled: isFormValid,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "o365Name",
        type: "text",
        fieldData: formData.o365Name,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: clientSecret == null ? void 0 : clientSecret.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "tenantId",
        type: "text",
        fieldData: formData.tenantId,
        onChange,
        label: t("o365.authorize.tenant_id"),
        help: t("o365.authorize.tenant_id_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        help: t("o365.authorize.client_id_help"),
        label: t("o365.authorize.client_id"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "clientSecret",
        type: "password",
        onChange,
        fieldData: formData.clientSecret,
        label: t("o365.authorize.client_secret"),
        help: t("o365.authorize.client_secret_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        name: "subscriptionType",
        id: "subscriptionType",
        onChange,
        fieldData: formData.subscriptionType,
        help: t("o365.authorize.subscription_type_help"),
        required: true,
        label: t("common.subscription.type")
      },
      renderOptions(subscriptions, t("common.subscription.choose"))
    )
  );
};
export default StepAuthorize;
